import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { categoriesAPI } from '../api';

export default function CategoriesPage() {
  const qc = useQueryClient();
  const { data: cats } = useQuery({ queryKey:['categories'], queryFn:() => categoriesAPI.list().then(r => r.data) });
  const [show, setShow]   = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm]   = useState({ name:'', icon:'📦', color:'#7c6af7' });

  const create = useMutation({ mutationFn: d => categoriesAPI.create(d), onSuccess: () => { qc.invalidateQueries(['categories']); setShow(false); setForm({ name:'', icon:'📦', color:'#7c6af7' }); toast.success('Cree !'); } });
  const update = useMutation({ mutationFn: ({id,d}) => categoriesAPI.update(id,d), onSuccess: () => { qc.invalidateQueries(['categories']); setEditId(null); setShow(false); toast.success('Mis a jour !'); } });
  const remove = useMutation({ mutationFn: id => categoriesAPI.remove(id), onSuccess: () => { qc.invalidateQueries(['categories']); toast.success('Supprimee'); } });

  const openAdd  = () => { setEditId(null); setForm({ name:'', icon:'📦', color:'#7c6af7' }); setShow(true); };
  const openEdit = (c) => { setEditId(c.id); setForm({ name:c.name, icon:c.icon, color:c.color }); setShow(true); };
  const save     = () => editId ? update.mutate({ id:editId, d:form }) : create.mutate(form);

  const inp = { background:'var(--surface2)', border:'1px solid var(--border)', borderRadius:10, padding:'12px 16px', color:'var(--text)', fontSize:14, outline:'none' };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <h1 style={{ fontFamily:'Syne,sans-serif', fontSize:24, fontWeight:700 }}>Categories</h1>
        <button onClick={openAdd} style={{ padding:'10px 20px', background:'var(--accent)', color:'#fff', border:'none', borderRadius:10, fontFamily:'Syne,sans-serif', fontWeight:700 }}>+ Ajouter</button>
      </div>

      {show && (
        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:16, padding:24, marginBottom:24 }}>
          <h3 style={{ fontFamily:'Syne,sans-serif', fontWeight:700, marginBottom:16 }}>{editId ? 'Modifier' : 'Nouvelle'} categorie</h3>
          <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1fr', gap:12, marginBottom:16 }}>
            <input value={form.name} onChange={e => setForm({...form, name:e.target.value})} placeholder="Nom" style={{ ...inp, width:'100%' }} />
            <input value={form.icon} onChange={e => setForm({...form, icon:e.target.value})} placeholder="Emoji" maxLength={4} style={{ ...inp, width:'100%' }} />
            <input type="color" value={form.color} onChange={e => setForm({...form, color:e.target.value})} style={{ ...inp, width:'100%', padding:4, height:46 }} />
          </div>
          <div style={{ display:'flex', gap:10 }}>
            <button onClick={save} style={{ padding:'10px 20px', background:'var(--accent)', color:'#fff', border:'none', borderRadius:10, fontFamily:'Syne,sans-serif', fontWeight:700 }}>Enregistrer</button>
            <button onClick={() => setShow(false)} style={{ padding:'10px 20px', background:'var(--surface2)', color:'var(--text)', border:'1px solid var(--border)', borderRadius:10 }}>Annuler</button>
          </div>
        </div>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))', gap:16 }}>
        {(cats || []).map(c => (
          <div key={c.id} style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:14, padding:18, display:'flex', alignItems:'center', gap:12 }}>
            <div style={{ width:44, height:44, borderRadius:12, background: c.color + '22', display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, flexShrink:0 }}>{c.icon}</div>
            <div style={{ flex:1 }}>
              <div style={{ fontWeight:600, fontSize:15 }}>{c.name}</div>
              <div style={{ display:'flex', alignItems:'center', gap:4, marginTop:4 }}>
                <div style={{ width:8, height:8, borderRadius:'50%', background:c.color }} />
                <span style={{ fontSize:12, color:'var(--text3)' }}>{c.color}</span>
              </div>
            </div>
            <div style={{ display:'flex', gap:6 }}>
              <button onClick={() => openEdit(c)} style={{ background:'none', border:'none', fontSize:16 }}>✏️</button>
              {!c.is_default && (
                <button onClick={() => { if (window.confirm('Supprimer ?')) remove.mutate(c.id); }} style={{ background:'none', border:'none', fontSize:16 }}>🗑️</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}